@if (!mergeDialog()) {
  <div formRow>
    <procure-input-text
      label="Weight (%)"
      numericInput
      [control]="weightControl()"
      [showMode]="showMode()"
    />
  </div>
} @else {
  <procure-input-text
    label="Weight (%)"
    numericInput
    [control]="weightControl()"
    [showMode]="showMode()"
  />
}
@if (subDimensionsControl().value.length || !showMode()) {
  <procure-card
    class="selection-dimension"
    flat
    [class.selection-dimension--show]="showMode()"
  >
    @if (group().get("subDimensions")?.errors?.full) {
      <div formRow>
        <procure-hint
          type="error"
          standalone
        >
          Sub-Dimension weights need to add up to 100% in total.
        </procure-hint>
      </div>
    }
    @if (!showMode()) {
      <div
        class="selection-dimension__add"
        [class.selection-dimension__add--empty]="!subDimensionsControl().value.length"
      >
        <button
          class="selection-dimension__button"
          procure-button
          color="primary"
          matTooltip="Add sub-dimension"
          (click)="openDimensionDialog()"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }
    @if (subDimensionsControl().value.length) {
      <procure-table
        class="selection-dimension__table"
        [hidePagination]="true"
      >
        <table
          aria-label="Sub-Dimensions"
          mat-table
          [dataSource]="subDimensionsControl().value"
        >
          <ng-container matColumnDef="subDimension">
            <th
              *matHeaderCellDef
              class="selection-dimension__column--subDimension"
              mat-header-cell
              mat-sort-header="subDimension"
            >
              Sub-Dimension
            </th>
            <td
              *matCellDef="let entity"
              mat-cell
            >
              {{ entity.name }}
            </td>
          </ng-container>
          <ng-container matColumnDef="weight">
            <th
              *matHeaderCellDef
              class="selection-dimension__column--weight"
              mat-header-cell
              mat-sort-header="weight"
            >
              Weight (%)
            </th>
            <td
              *matCellDef="let entity"
              mat-cell
            >
              {{ entity.weight }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th
              *matHeaderCellDef
              class="selection-dimension__column--actions"
              mat-header-cell
              mat-sort-header="actions"
            >
              Actions
            </th>
            <td
              *matCellDef="let entity; let index = index"
              mat-cell
            >
              <button
                procure-button
                variant="ghost"
                color="primary"
                matTooltip="Edit"
                (click)="openDimensionDialog(entity, index)"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                procure-button
                variant="ghost"
                color="primary"
                matTooltip="Remove"
                (click)="removeSubDimension(index)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr *matNoDataRow>
            <td [attr.colspan]="displayedColumns().length">There are no sub-dimensions for this dimension.</td>
          </tr>
          <tr
            *matHeaderRowDef="displayedColumns()"
            mat-header-row
          ></tr>
          <tr
            *matRowDef="let row; columns: displayedColumns()"
            mat-row
          ></tr>
        </table>
      </procure-table>
    }
  </procure-card>
}
